<template>
  <div class="footer">
    <el-row type="flex" justify="center" align="middle" style="height: 60px;font-size: 14px;font-weight: 500;line-height: 17px;
    color: #fff;padding-right: 15%">
      <a href="JavaScript:void(0)" style="font-size: 14px;font-weight: 500;line-height: 17px;
color: #868686;">{{$store.getters.systemConfig.notaryName}}</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span style="color: #868686">咨询电话：<span style="color: #2C69EC;">{{$store.getters.systemConfig.notaryPhone}}</span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span style="color: #868686">{{$store.getters.systemConfig.icp}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span style="font-size: 14px;font-weight: 500;line-height: 17px;
color: #868686;">
        友情链接：<a href="https://www.ebaoquan.org/" style="
color: #BFBFBF;font-size: 14px;border-bottom: 1px solid #BFBFBF">易保全</a>
         <a href="https://www.junziqian.com/" style="
color: #BFBFBF;font-size: 14px;border-bottom: 1px solid #BFBFBF;margin: 0 20px">君子签</a>
         <a href="https://www.wbq360.com/" style="
color: #BFBFBF;font-size: 14px;border-bottom: 1px solid #BFBFBF">微版权</a>
      </span>&nbsp;&nbsp;&nbsp;
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'indexFooter'
}
</script>

<style scoped lang="less">
.footer{
  width: 100%;
  height: 60px;

  background: #FAFAFA;

}
</style>



// WEBPACK FOOTER //
// src/components/indexFooter.vue